export const MC_NUMBER_REGEX = /\bMC\s*#?\s*(\d{4,8})\b/gi;
export const DAT_ONE_ZONE_REGEX = /^(Z[0-9ECWM])$/;
